<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-x
    style="z-index: 999">
    <template v-slot:activator="{ on, attrs }">
    <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        data-testid="dm-title-context-menu"
        class="context-menu-btn-dm-title"
    >
        <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
    </template>
    <v-card style="max-width: 370px">
      <v-card-title>
        <v-icon class="mr-3">mdi-cog</v-icon>
        <span>{{ $t('chat.dmContextMenu.title') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="menu = false">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <span>{{ $t('chat.dmContextMenu.filterSortBy') }}</span>
        <Sort/>
          <br />
        <ClosedFilter />
        <ReadFilter />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Sort from '@/components/chat/drawer/direct_chats/dm_context_menu/sort'
import ClosedFilter from '@/components/chat/drawer/direct_chats/dm_context_menu/closed_filter.vue'
import ReadFilter from '@/components/chat/drawer/direct_chats/dm_context_menu/read_filter.vue'

export default {
  name: 'chat-dm-title-contextmenu',
  data () {
    return {
      menu: false
    }
  },
  components: {
    Sort, ClosedFilter, ReadFilter
  },
  computed: {
    ...mapGetters({
      paginationDm: 'chat/paginationDm'
    })
  }
}
</script>

<style>

</style>
